import React from "react";
import { Spinner } from "components/ui";


const Loader = ({
  text = "Loading...",
  inline = false,
  size = inline ? 18 : 32,
  className = "",
}) => {
  if (inline) {
    return (
      <span className={`inline-flex items-center gap-2 text-sm text-gray-500 ${className}`}>
        <Spinner size={size} />
        {text}
      </span>
    );
  }

  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 py-12 text-sm text-gray-500 ${className}`}
    >
      <Spinner size={size} />
      {text ? <span>{text}</span> : null}
    </div>
  );
};

export default Loader;
